module.exports = __webpack_public_path__ + "img/social-data-mediagate-logo.0276d8f1.png";